import tokens from '../../../foundation/tokens/js/tokens';
// Mappings.
// -----------------------------------------------------------------------------
export const DEFAULT_BASE_TABLE_ALIGN = 'left';
export const DEFAULT_BASE_TABLE_BORDER_TYPE = 'row';
export const DEFAULT_BASE_TABLE_FULL_WIDTH = false;
export const DEFAULT_BASE_TABLE_MODE = 'light';
export const DEFAULT_BASE_TABLE_ZEBRA = false;
export const MAP_CELL_MODES = {
    dark: {
        actionsColor: tokens.colors.emerald[500].value,
        bgColor: tokens.colors.black[100].value,
        bgColorHover: tokens.colors.midnight[850].value,
        borderColor: tokens.colors.midnight[700].value,
        iconColor: tokens.colors.midnight[100].value,
        textColor: tokens.colors.midnight[200].value,
        thColorHover: tokens.colors.midnight[850].value
    },
    light: {
        actionsColor: tokens.colors.midnight[800].value,
        bgColor: tokens.colors.white[100].value,
        bgColorHover: tokens.colors.midnight[100].value,
        borderColor: tokens.colors.midnight[200].value,
        iconColor: tokens.colors.midnight[800].value,
        textColor: tokens.colors.midnight[800].value,
        thColorHover: tokens.colors.midnight[150].value
    }
};
export const MAP_CELL_STYLES = {
    // Size 's'.
    s: {
        actions: {
            paddingX: 'l',
            paddingY: 'l',
            fontSize: 'l' // 20px
        },
        badge: {
            paddingX: 'm',
            paddingY: 'm',
            fontSize: 'xs' // 12px
        },
        button: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        free: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 's' // 14px
        },
        icon: {
            paddingX: 'l',
            paddingY: 'l',
            fontSize: 'l' // 20px
        },
        number: {
            paddingY: 'xl',
            paddingX: 'l',
            fontSize: 's' // 14px
        },
        text: {
            paddingY: 'xl',
            paddingX: 'l',
            fontSize: 's' // 14px
        }
    },
    // Size 'xs'.
    xs: {
        actions: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'm' // 16px
        },
        badge: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        button: {
            paddingX: 'xs',
            paddingY: 'xs',
            fontSize: '2xs' // 12px
        },
        free: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 's' // 14px
        },
        icon: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'm' // 16px
        },
        number: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        text: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        }
    }
};
export const MAP_HEADERS_STYLES = {
    // Size 's'.
    s: {
        paddingY: 'xl',
        paddingX: 'l',
        fontSize: 's' // 14px
    },
    // Size 'xs'.
    xs: {
        paddingX: 's',
        paddingY: 's',
        fontSize: 'xs' // 12px
    }
};
//# sourceMappingURL=BaseTable.constants.js.map